import { useGroupsOverviewListQuery } from 'core/graphql';

export interface IGroupOverview {
  groupId: string;
  name: string;
  course: string;
  startDate: string | null;
  studentsCount: number;
  debtTotal: number;
  debtCurrency: string;
  debtorsCount: number;
  unansweredCount: number;
  openTasksCount: number;
  overdueTasksCount: number;
}

interface IUseGroupsOverview {
  groups: IGroupOverview[];
  loading: boolean;
}

/**
 * Account-manager command-center rollup (spec 0003 redesign): one row per
 * group with REAL (contribution-based) debt + unanswered/task signals.
 */
export const useGroupsOverview = (
  search?: string,
  onlyIssues?: boolean,
  pollInterval?: number,
): IUseGroupsOverview => {
  const { data, loading } = useGroupsOverviewListQuery({
    variables: { search: search || null, onlyIssues: Boolean(onlyIssues) },
    fetchPolicy: 'cache-and-network',
    pollInterval,
  });
  return {
    groups: (data?.groupsOverview || []) as IGroupOverview[],
    loading,
  };
};
